/**
 * @module experience/landing/common
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */
/** */
// interfaces
import { LineSummary } from '@support/api/proxies/responses/api-2006.interface';
import {
  Line,
  Devicedetails,
} from '@experience/landing/common/components/account-landing/interfaces/account-lines-device-details.interface';
import { CustomerAccountLineDeviceDetails } from '@support/api/proxies/responses/api-2022.interface';
// service
import { CommonUtilService } from '@support/shared/services/common-util.service';
// constants
import {
  ACCOUNT_LANDING_CONSTANTS,
  ORDER_TYPES,
} from '@experience/landing/common/constants/account-landing.constants';
import { StateStoreUtilsService } from '@support/state-object-hash-utilities/utils/state-store-utils.service';

export class AccountLineDetailsModel {
  /**
   * stores line details as input from account landing
   */
  public customerAccountLineDetails: Line[];

  constructor(
    linesInfo: LineSummary[],
    private commonUtilService: CommonUtilService,
    private stateStoreUtilsService: StateStoreUtilsService
  ) {
    this.customerAccountLineDetails = linesInfo;
    if (this.customerAccountLineDetails && this.customerAccountLineDetails.length) {
      this.customerAccountLineDetails[0].isActive = true;
    }
  }
  /**
   * Method to set device details on every line blade click
   * @param {CustomerAccountLineDeviceDetails} customerAccountLineDeviceDetails
   * @param {number} index
   * @returns void
   */
  public getDeviceDetails(
    customerAccountLineDeviceDetails: CustomerAccountLineDeviceDetails,
    index: number
  ): void {
    if (customerAccountLineDeviceDetails) {
      const totalLines: number = this.customerAccountLineDetails.length;
      for (let line = 0; line < totalLines; line++) {
        this.customerAccountLineDetails[index].devicedetails =
          customerAccountLineDeviceDetails.devicedetails;
      }
    }
  }
  /**
   * Method to set expand/collapse property of line blades
   * @param {number} bladeIndex
   * @param {boolean} active
   * @returns void
   */
  public updateActiveBladeIndex(bladeIndex: number, active: boolean): void {
    const totalLines: number = this.customerAccountLineDetails.length;
    for (let key = 0; key < totalLines; key++) {
      this.customerAccountLineDetails[bladeIndex].isActive = active;
    }
  }
}
